import { reactive } from "vue"

const Media = reactive({
	media   : null,
	size    : null,
	isMobile: null,
})

const mediaList = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl']
const resizeCallbacks = new Set()
const updateMedia = size => {
	let media = 'xs'

	if (size < 540  ) media = 'xs'
	if (size >= 540 ) media = 'sm'
	if (size >= 720 ) media = 'md'
	if (size >= 960 ) media = 'lg'
	if (size >= 1140) media = 'xl'
	if (size >= 1200) media = 'xxl'

	Media.media = media
	Media.size  = size
}
const resizeObserver = new ResizeObserver(entries => {
	const contentBoxSize = Array.isArray(entries[0].contentBoxSize) ? entries[0].contentBoxSize[0] : entries[0].contentBoxSize

	// Atualizando o valor de Media
	updateMedia(contentBoxSize.inlineSize)

	// Disparando os callbacks
	resizeCallbacks.forEach(callback => callback({
		target: entries[0].target,
		contentBoxSize,
		contentRect: entries[0].contentRect
	}))
})
/**
 *
 * @param {Function} fn - Callback para a troca de midia
 * @returns void
 */
const $onMediaChange = (fn) => resizeCallbacks.add(fn)
/**
 *
 * @param {String} mediaSize - xs|sm|md|lg|xl|xxl
 * @param {Function} fn
 */
const $mediaBreackpointUp = (mediaSize, fn) => {
	const start   = mediaList.indexOf(mediaSize)
	const targets = mediaList.slice(start, mediaList.length)

	for(const media of targets) {
		$onMediaChange(() => {
			if(Media.media == media) fn()
		})
	}
}
/**
 *
 * @param {String} mediaSize - xs|sm|md|lg|xl|xxl
 * @param {Function} fn
 */
const $mediaBreackpointDown = (mediaSize, fn) => {
	const start   = mediaList.indexOf(mediaSize)
	const targets = mediaList.slice(0, start)

	for(const media of targets) {
		$onMediaChange(() => {
			if(Media.media == media) fn()
		})
	}
}

// Observando a tag <html>
resizeObserver.observe(document.documentElement)

$mediaBreackpointDown('lg', () => Media.isMobile = true)

$mediaBreackpointUp('lg', () => Media.isMobile = false)

export default function useMediaBreckpoint() {

	return {
		Media,
		$onMediaChange,
		$mediaBreackpointUp,
		$mediaBreackpointDown
	}
}
